import { Typography } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { NotConfiguredProps } from './types'

const NotConfigured: React.VFC<NotConfiguredProps> = (props) => {
  const name = useCIMSNotificationsPanelContext().event.name
  const common =
    'No Recipients have been configured to receive an email for' as const
  if (props.type === 'Every')
    return (
      <Typography.Text>
        {common} every {name} event, on every Engineering Judgement
      </Typography.Text>
    )
  return null
}

export default NotConfigured
